/**
 * ErrorPreview.jsx - Preview error page for design/testing
 *
 * Visit /error to see the error page without triggering a real error.
 * Only available in development mode.
 */

const ErrorPreview = () => {
  const isDev = process.env.NODE_ENV === 'development';

  if (!isDev) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <p>Error preview is only available in development mode.</p>
      </div>
    );
  }

  // Generate a sample error ID
  const sampleErrorId = 'err_sample123abc';

  return (
    <div className="error-boundary">
      <div className="error-boundary-content">
        <div className="error-brand">Ramp.ai</div>

        <h2>Something went wrong</h2>
        <p className="error-message">
          We couldn't complete your request. Don't worry — you haven't been charged.
        </p>

        <details className="error-details">
          <summary>Error details (dev only)</summary>
          <pre>Error: Sample error for preview</pre>
          <pre className="error-stack">
            at SampleComponent (src/Example.jsx:42:15) at renderWithHooks (react-dom.js:1234:22)
          </pre>
        </details>

        <div className="error-actions">
          <button onClick={() => window.location.reload()} className="error-btn error-btn-primary">
            Try again
          </button>
        </div>

        <div className="error-footer">
          <p className="error-id">Error ID: {sampleErrorId}</p>
          <p className="error-footer-help">
            Having trouble? <a href="mailto:support@rampwithai.com">Contact support</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ErrorPreview;
